"use strict";

exports.__esModule = true;
exports.Form = void 0;

var _hooks = require("@bydesign-ui/hooks");

var _utils = require("@bydesign-ui/utils");

var _memCache = require("../../../models/mem-cache");

var _nestWatcher = require("../../../models/nest-watcher");

var _types = require("../types");

var _util = require("../util");

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Form = function (_Emitter) {
  _inheritsLoose(Form, _Emitter);

  function Form(options) {
    var _this;

    _this = _Emitter.call(this) || this;
    _this.map = {};
    var _options$scrollToFirs = options.scrollToFirstError,
        scrollToFirstError = _options$scrollToFirs === void 0 ? false : _options$scrollToFirs,
        _options$saveMemCache = options.saveMemCache,
        saveMemCache = _options$saveMemCache === void 0 ? true : _options$saveMemCache,
        _options$model = options.model,
        model = _options$model === void 0 ? {} : _options$model;
    _this.id = (0, _utils.guid)();
    _this.watcher = new _nestWatcher.NestWatcher();
    _this.root = new _hooks.DomNode({
      type: _types.FormNodeType.ROOT,
      field: '',
      id: '',
      cache: new _memCache.MemCache()
    });
    _this.scrollToFirstError = scrollToFirstError;
    _this.saveMemCache = saveMemCache;
    _this.model = model;

    _this.init();

    return _this;
  }

  var _proto = Form.prototype;

  _proto.setScrollToFirstError = function setScrollToFirstError(scroll) {
    this.scrollToFirstError = scroll;
  };

  _proto.getScrollToFirstError = function getScrollToFirstError() {
    return this.scrollToFirstError;
  };

  _proto.setSaveMemCache = function setSaveMemCache(save) {
    this.saveMemCache = save;
  };

  _proto.getSaveMemCache = function getSaveMemCache() {
    return this.saveMemCache;
  };

  _proto.getRootNode = function getRootNode() {
    return this.root;
  };

  _proto.getField = function getField(id) {
    return this.map[id];
  };

  _proto.getFieldsByPath = function getFieldsByPath(path) {
    var _this2 = this;

    var fields = this.root.getSubNodes(function (node) {
      var _node$getValue = node.getValue(),
          type = _node$getValue.type;

      if (type !== _types.FormNodeType.FIELD) {
        return null;
      }

      return true;
    }).map(function (node) {
      var _node$getValue2 = node.getValue(),
          id = _node$getValue2.id;

      return _this2.map[id];
    }).filter(function (field) {
      return _nestWatcher.NestWatcher.keyIsMatch(path, field.getPath());
    });

    if (!fields.length) {
      console.warn("path\u4E3A" + path + "\u7684field\u4E0D\u5B58\u5728");
    }

    return fields;
  };

  _proto.register = function register(field) {
    this.map[field.id] = field;
  };

  _proto.unregister = function unregister(field) {
    delete this.map[field.id];
  };

  _proto.dispose = function dispose() {
    var _this3 = this;

    Object.keys(this.map).forEach(function (key) {
      return _this3.map[key].dispose();
    });
  };

  _proto.disposeNode = function disposeNode(node) {
    var _node$getValue3 = node.getValue(),
        id = _node$getValue3.id;

    this.map[id].dispose();
  };

  _proto.watch = function watch(id, scope, paths, callback, lazy) {
    var _this4 = this;

    if (lazy === void 0) {
      lazy = false;
    }

    var valueKeys = paths.map(function (path) {
      return (0, _util.processRelativeKey)(scope || _this4.root, path);
    });
    var watchKeys = paths.map(function (path) {
      return (0, _util.processNestWatcherKey)(scope || _this4.root, path);
    });
    var values = valueKeys.map(function (key) {
      return _this4.getPathValue(key);
    });
    this.absoluteWatch(id, watchKeys, function (changes, flags) {
      var old = values;
      values = valueKeys.map(function (key) {
        return _this4.getPathValue(key);
      });
      var updated = valueKeys.some(function (key, idx) {
        return old[idx] !== values[idx];
      });

      if (updated) {
        callback(changes, flags);
      }
    }, lazy);
  };

  _proto.absoluteWatch = function absoluteWatch(id, paths, callback, lazy) {
    if (lazy === void 0) {
      lazy = false;
    }

    this.watcher.register(id, paths.map(function (item) {
      return 'model.' + item;
    }), (0, _util.wrapFunction)(callback), lazy);
  };

  _proto.unwatch = function unwatch(id) {
    this.watcher.unregister(id);
  };

  _proto.getModel = function getModel() {
    return this.model;
  };

  _proto.getPathValue = function getPathValue(path) {
    return (0, _utils.getObjectProperty)(this.model, _nestWatcher.NestWatcher.splitKey(path));
  };

  _proto.setPathValue = function setPathValue(path, value, isSilent, flags) {
    if (isSilent === void 0) {
      isSilent = false;
    }

    if (flags === void 0) {
      flags = {};
    }

    var res = (0, _utils.setObjectProperty)(this.model, value, _nestWatcher.NestWatcher.splitKey(path));

    if (!isSilent) {
      this.watcher.notify(['model.' + path], Object.assign(flags, {
        manual: true
      }));
    }

    return res;
  };

  _proto.deletePathValue = function deletePathValue(path) {
    (0, _utils.deleteObjectProperty)(this.model, _nestWatcher.NestWatcher.splitKey(path));
  };

  _proto.updateModel = function updateModel(model) {
    this.model = model;
    this.watcher.notify(['model']);
  };

  _proto.submit = function submit() {
    var _this5 = this;

    this.validate().then(function (success) {
      if (success) {
        _this5.emit('submit', _this5.model);

        return;
      }

      _this5.emit('submit-failed', _this5.getErrors());
    }).catch(function () {
      return console.warn('this will not reached');
    });
  };

  _proto.validate = function validate() {
    var _this6 = this;

    var fields = this.processNeedValidateFields();
    return Promise.all(fields.map(function (field) {
      return field.validate('force');
    })).then(function () {
      var fields = _this6.processNeedValidateFields();

      if (fields.length > 0) {
        fields[0].emit('focus');
        return false;
      }

      return true;
    });
  };

  _proto.validateField = function validateField(path, trigger) {
    var _this7 = this;

    if (trigger === void 0) {
      trigger = 'manual';
    }

    var fields = this.getFieldsByPath(path);
    return Promise.all(fields.map(function (field) {
      return field.validate(trigger);
    })).then(function () {
      var needValdateFields = _this7.processNeedValidateFields(fields);

      return !needValdateFields.length;
    });
  };

  _proto.validateFields = function validateFields(paths) {
    var _this8 = this;

    return Promise.all(paths.map(function (path) {
      return _this8.validateField(path);
    })).then(function (res) {
      return res.every(function (field) {
        return field;
      });
    });
  };

  _proto.getFieldsErrors = function getFieldsErrors(paths) {
    var _this9 = this;

    var fields = paths.reduce(function (sum, path) {
      return sum.concat(_this9.getFieldsByPath(path));
    }, []);
    return this.processNeedValidateFields(fields).map(function (item) {
      return item.getValidateError();
    });
  };

  _proto.reset = function reset() {
    var _this10 = this;

    Object.keys(this.map).forEach(function (key) {
      return _this10.map[key].reset();
    });
  };

  _proto.resetField = function resetField(path) {
    var fields = this.getFieldsByPath(path);
    fields.forEach(function (field) {
      return field.reset();
    });
  };

  _proto.resetFields = function resetFields(paths) {
    var _this11 = this;

    paths.forEach(function (path) {
      return _this11.resetField(path);
    });
  };

  _proto.getErrors = function getErrors() {
    return this.processNeedValidateFields().map(function (item) {
      return item.getValidateError();
    });
  };

  _proto.dispatchValidateResult = function dispatchValidateResult(key, node, result) {
    var scope = node.parentNode;

    while (scope != null) {
      var _scope$getValue = scope.getValue(),
          id = _scope$getValue.id,
          type = _scope$getValue.type;

      if (type === _types.FormNodeType.GROUP) {
        var field = this.map[id];

        if (field && field.isGroup()) {
          field.processValidateResult(id, result);
        }
      }

      scope = scope.parentNode;
    }
  };

  _proto.processNeedValidateFields = function processNeedValidateFields(needFields) {
    var _this12 = this;

    var fields = needFields;

    if (!fields) {
      fields = this.root.getSubNodes(function (node) {
        var _node$getValue4 = node.getValue(),
            type = _node$getValue4.type;

        if (type !== _types.FormNodeType.FIELD) {
          return null;
        }

        return true;
      }).map(function (node) {
        var _node$getValue5 = node.getValue(),
            id = _node$getValue5.id;

        return _this12.map[id];
      });
    }

    return fields.filter(function (field) {
      var _field$getFieldInfo = field.getFieldInfo(),
          valid = _field$getFieldInfo.valid,
          partial = _field$getFieldInfo.partial;

      return !valid || partial;
    });
  };

  _proto.init = function init() {
    var _this13 = this;

    this.absoluteWatch(this.id, ['*'], function (changes) {
      _this13.emit('model-change', _this13.getModel());

      _this13.emit('values-change', changes.map(function (fieldPath) {
        return fieldPath.replace(/^model\./, '');
      }));
    });
  };

  return Form;
}(_hooks.Emitter);

exports.Form = Form;